<template>
  <div class="coupon">
    <van-sticky>
      <van-nav-bar title="优惠券中心" left-arrow @click-left="goback()" />
    </van-sticky>

    <van-pull-refresh
      v-model="refreshing"
      success-text="刷新成功"
      @refresh="onRefresh"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        :immediate-check="false"
      >
        <div
          class="coupon_list"
          v-for="(item, index) in couponList"
          :key="index"
        >
          <div class="list_item">
            <div class="item">
              <div class="item_name line2">
                {{ item.couponVo.name }}
                <!-- {{ item.couponVo.site_supplier_name }} -->
              </div>
              <!-- <span>满￥{{ item.couponVo.price_full }}元使用</span> -->
            </div>
            <div style="color: #ff6d58">满￥{{ item.couponVo.price_full }}元使用</div>
            <div>
              有效期{{ item.couponVo.beginDate }}至{{ item.couponVo.endDate }}
            </div>
          </div>
          <div class="list_price">
            <div class="price">
              <span>￥</span>
              <div>{{ item.couponVo.price_reduce }}</div>
            </div>
            <span v-if="item.status === '0'">{{ item.status_name }}</span>
            <span style="background: #acacbd" v-else>{{
              item.status_name
            }}</span>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { Button, Icon, Image, Tag, List, PullRefresh, Notify } from "vant";
export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Image.name]: Image,
    [Tag.name]: Tag,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
  },
  data() {
    return {
      params: {
        keyword: "",
        page: 1,
        size: 8,
      },
      //优惠券列表
      couponList: [],
      loading: false, //底部加载状态
      finished: false, //底部是否完成状态
      refreshing: false,
    };
  },

  created() {
    // 优惠券管理-列表
    this.getCouponList();
  },

  methods: {

    //下拉刷新
    onRefresh() {
      var that = this;
      setTimeout(() => {
        that.params.page = 1;
        // 优惠券管理-列表
        that.getCouponList();
        that.refreshing = false;
        that.finished = false;
      }, 1000);
    },

    //上拉加载
    onLoad() {
      var that = this;
      setTimeout(() => {
        that.getCouponList();
      }, 1000);
    },

    // 优惠券管理-列表
    getCouponList() {
      var that = this;
      that.$api
        .couponCollectListByUserIdAPI(that.params)
        .then(function (res) {
          if (res.data.code === 200) {
            // 如果是第一次进入页面page==1 直接赋值
            if (that.params.page === 1) {
              that.couponList = res.data.dataList;
            } else {
              that.couponList = [...that.couponList, ...res.data.dataList];
            }
            // 当还有数据是page++
            if (res.data.dataList.length > 0) {
              that.params.page++;
              that.loading = false;
            } else {
              // 如果没有数据加载完毕
              that.finished = true;
            }
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    onsubmit() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.coupon {
  .coupon_list {
    margin: auto;
    background-image: url("/static/images/coupon.jpg");
    background-size: 100%; /*设置图片大小*/
    background-repeat: no-repeat;
    width: 90%;
    height: 124px;
    border-radius: 5px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .list_item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 70%;
      width: 200px;
      margin-left: 20px;
      font-size: 13px;
      color: #999;

      .item {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        font-weight: bold;
        color: #000;

        .item_name {
          width: 100px;
        }

        span {
          color: #ff6d58;
        }
      }
    }

    .list_price {
      display: flex;
      flex-direction: column;
      width: 100px;
      border-left: 1px dashed #f1f2f7;
      align-items: center;
      justify-content: flex-end;
      height: 100%;

      .price {
        display: flex;
        align-items: flex-end;
        font-size: 25px;
        color: #ff6d58;
        font-weight: bold;
        span {
          font-size: 12px;
        }
      }

      > span {
        margin-bottom: 15px;
        font-size: 12px;
        background: #ff6d58;
        padding: 4px 10px;
        color: #fff;
        border-radius: 5px;
        margin-top: 8px;
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/personal/getCouponCenter.vue